export const SIDEBAR_ID = 'sidebar';
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
